var map = {
	"./ic_add_daily.svg": "bbda",
	"./ic_add_dark.svg": "b17c",
	"./ic_add_method.svg": "34bb",
	"./ic_android.svg": "474b",
	"./ic_assets_daily.svg": "4dfd",
	"./ic_assets_dark.svg": "d240",
	"./ic_assetsa_daily.svg": "5657",
	"./ic_assetsa_dark.svg": "3666",
	"./ic_audit_fail.svg": "cd54",
	"./ic_auditing.svg": "1cab",
	"./ic_back.svg": "67ab",
	"./ic_back_mining.svg": "e1f6",
	"./ic_behavior1.svg": "9ff2",
	"./ic_behavior2.svg": "e208",
	"./ic_behavior3.svg": "8f85",
	"./ic_behavior4.svg": "2278",
	"./ic_behavior5.svg": "71d3",
	"./ic_behavior6.svg": "f646",
	"./ic_behavior7.svg": "2230",
	"./ic_behavior8.svg": "0c64",
	"./ic_bgright.svg": "11c4",
	"./ic_close_clean.svg": "fec4",
	"./ic_coin_daily.svg": "6675",
	"./ic_coin_dark.svg": "d9f7",
	"./ic_coincard_daily.svg": "c657",
	"./ic_coincard_dark.svg": "cb8a",
	"./ic_constract_daily.svg": "2e30",
	"./ic_constract_dark.svg": "9b05",
	"./ic_copy.svg": "e361",
	"./ic_cup_icon.svg": "6a4a",
	"./ic_customer.svg": "6d8f",
	"./ic_customer_dark.svg": "4be4",
	"./ic_daily.svg": "8c75",
	"./ic_dark.svg": "abb9",
	"./ic_del_method.svg": "9aff",
	"./ic_down.svg": "4289",
	"./ic_down_dark.svg": "2115",
	"./ic_down_light.svg": "3e16",
	"./ic_down_line.svg": "cf31",
	"./ic_exchange.svg": "f224",
	"./ic_exchange_daily.svg": "ac13",
	"./ic_exchange_dark.svg": "9654",
	"./ic_exchangea_daily.svg": "46cf",
	"./ic_exchangea_dark.svg": "655f",
	"./ic_eye.svg": "1a97",
	"./ic_eye_open.svg": "4d01",
	"./ic_feedback.svg": "7c5e",
	"./ic_feedback_dark.svg": "6f3b",
	"./ic_fiat_chat_add.svg": "303a",
	"./ic_fiat_chat_send.svg": "1b55",
	"./ic_fiat_exchange.svg": "c20c",
	"./ic_fiat_header.svg": "9069",
	"./ic_fiat_shop_add.svg": "7c65",
	"./ic_fiat_shop_makeorder.svg": "469e",
	"./ic_fiat_shop_makeorder_no.svg": "3be6",
	"./ic_fiat_shop_order.svg": "23ed",
	"./ic_fiat_shop_order_no.svg": "87d3",
	"./ic_fiat_shop_paymethod.svg": "3342",
	"./ic_fiat_shop_paymethod_no.svg": "5d66",
	"./ic_flash_order.svg": "fa4c",
	"./ic_follow_order.svg": "44f4",
	"./ic_foreign_account.svg": "d008",
	"./ic_foreign_all.svg": "cc1c",
	"./ic_foreign_close.svg": "81e3",
	"./ic_foreign_date.svg": "0c40",
	"./ic_foreign_fastexchange.svg": "c9b8",
	"./ic_foreign_kline.svg": "84b7",
	"./ic_foreign_kline1.svg": "44e73",
	"./ic_foreign_kline2.svg": "e548",
	"./ic_foreign_kline3.svg": "a0a7",
	"./ic_foreign_lazhu.svg": "5cd5",
	"./ic_foreign_menu.svg": "9f4b",
	"./ic_foreign_mianji.svg": "1bfb",
	"./ic_foreign_modal.svg": "0e0f",
	"./ic_foreign_neworder.svg": "abba",
	"./ic_foreign_search.svg": "347c",
	"./ic_foreign_success.svg": "113a",
	"./ic_foreign_toright.svg": "e318",
	"./ic_foreign_zhu.svg": "7e2c",
	"./ic_game_left.svg": "c175",
	"./ic_game_right.svg": "dde4",
	"./ic_gantan.svg": "ecca",
	"./ic_green_up.svg": "c103",
	"./ic_head_download.svg": "b23f",
	"./ic_head_gg.svg": "c280",
	"./ic_head_letter.svg": "9ef7",
	"./ic_help.svg": "6581",
	"./ic_help_daily.svg": "291c",
	"./ic_help_dark.svg": "7570",
	"./ic_home_daily.svg": "c2f2",
	"./ic_home_dark.svg": "0ea9",
	"./ic_home_level.svg": "b4a9",
	"./ic_homea_daily.svg": "5379",
	"./ic_homea_dark.svg": "3088",
	"./ic_hook.svg": "6603",
	"./ic_icon_down.svg": "47d0",
	"./ic_icon_star_off.svg": "586f",
	"./ic_icon_star_on.svg": "d8d2",
	"./ic_idcard_daily.svg": "f0b0",
	"./ic_idcard_dark.svg": "1e6a",
	"./ic_increase.svg": "31af",
	"./ic_invite1.svg": "ce9f",
	"./ic_invite2.svg": "eb19",
	"./ic_invite3.svg": "0cee",
	"./ic_invite_why.svg": "fc73",
	"./ic_ios.svg": "6c22",
	"./ic_level_daily.svg": "4276",
	"./ic_level_dark.svg": "9730",
	"./ic_levela_daily.svg": "a12c",
	"./ic_levela_dark.svg": "14d1",
	"./ic_loading.svg": "58bc",
	"./ic_loan_add.svg": "3141",
	"./ic_loan_back.svg": "edb4",
	"./ic_loan_currency.svg": "c680",
	"./ic_loan_defi.svg": "6108",
	"./ic_loan_down.svg": "ed22",
	"./ic_loan_fast.svg": "3f46",
	"./ic_loan_get.svg": "cfa3",
	"./ic_loan_huazhuan.svg": "331b",
	"./ic_loan_notice.svg": "23e71",
	"./ic_loan_opreat.svg": "4122",
	"./ic_loan_pledge.svg": "eeab",
	"./ic_loan_profit.svg": "307d",
	"./ic_loan_redemption.svg": "710c",
	"./ic_loan_repay.svg": "0b29",
	"./ic_loan_set.svg": "18db",
	"./ic_loan_weath.svg": "8024",
	"./ic_menu_bibi.svg": "9c28",
	"./ic_menu_day.svg": "236b",
	"./ic_menu_feedback.svg": "e83e",
	"./ic_menu_futures_trust.svg": "da10",
	"./ic_menu_help.svg": "c3d6",
	"./ic_menu_invite.svg": "3701",
	"./ic_menu_night.svg": "63df",
	"./ic_menu_security.svg": "4049",
	"./ic_menu_setting.svg": "eb47",
	"./ic_menu_share.svg": "57b2",
	"./ic_method_dialog.svg": "b5bd",
	"./ic_method_email.svg": "5954",
	"./ic_method_short.svg": "e773",
	"./ic_method_sounds.svg": "f6be",
	"./ic_mining_pool.svg": "b9f0",
	"./ic_more_trad.svg": "70f2",
	"./ic_my_wealth.svg": "3a57",
	"./ic_next.svg": "fe7e",
	"./ic_nft_refrash.svg": "7a09",
	"./ic_order_add.svg": "31e7",
	"./ic_order_hasmsg.svg": "b924",
	"./ic_order_nomsg.svg": "bda7",
	"./ic_pay_viewimg.svg": "74ca",
	"./ic_person_location.svg": "bb5d",
	"./ic_person_time.svg": "3c70",
	"./ic_player_replay.svg": "fc85",
	"./ic_pointer.svg": "9de5",
	"./ic_question.svg": "b1e0",
	"./ic_quote.svg": "dc99",
	"./ic_quotes_daily.svg": "6e4a",
	"./ic_quotes_dark.svg": "ea53",
	"./ic_quotesa_daily.svg": "fc8e",
	"./ic_quotesa_dark.svg": "0ecb",
	"./ic_recharge_daily.svg": "8e14",
	"./ic_recharge_dark.svg": "ecb1",
	"./ic_red_down.svg": "ca83",
	"./ic_relevant_info.svg": "394b",
	"./ic_scroll_top.svg": "450cd",
	"./ic_search.svg": "bd0a",
	"./ic_search_empty.svg": "a867",
	"./ic_secondlevel.svg": "0ae3",
	"./ic_serverbox.svg": "065c",
	"./ic_sgd_sub.svg": "cd0f",
	"./ic_shop.svg": "9429",
	"./ic_speaker_daily.svg": "ad04",
	"./ic_speaker_dark.svg": "1cd9",
	"./ic_star_normal.svg": "0337",
	"./ic_star_select.svg": "e07b",
	"./ic_success.svg": "ba38",
	"./ic_test_fail.svg": "933e",
	"./ic_test_success.svg": "4ba5",
	"./ic_third_down.svg": "a95c",
	"./ic_third_up.svg": "d883",
	"./ic_to_bottom.svg": "dfa3",
	"./ic_trading_left.svg": "ff0e",
	"./ic_trading_right.svg": "1d0d",
	"./ic_up.svg": "b894",
	"./ic_up_dark.svg": "9691",
	"./ic_up_line.svg": "5dc8",
	"./ic_upload.svg": "6648",
	"./ic_window.svg": "ba6e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2349";